import { useCallback, useEffect, useState } from "react";
import {debounce} from 'lodash';


export const useSearchTextInput = (initialValue = '', delayMs = 2000) => {
    const [search, setSearch] = useState(initialValue);
    const [input, setInput] = useState(initialValue);
    
    const debouncedSetSearch = useCallback(
        debounce(text => {
            setSearch(text);
        }, delayMs),
        [delayMs],
    );

    useEffect(() => {
        return () => {
            debouncedSetSearch.cancel();
        };
    }, [debouncedSetSearch]);

    const handleChange = useCallback(
        text => {
            setInput(text);
            debouncedSetSearch(text);
        },
        [debouncedSetSearch],
    );

    const handleReset = useCallback(() => {
        setSearch('');
        setInput('');
        debouncedSetSearch.cancel();
    }, [debouncedSetSearch]);

    const sync = useCallback(
        text => {
            const next = text == null ? '' : String(text);
            setSearch(next);
            setInput(next);
            debouncedSetSearch.cancel();
        },
        [debouncedSetSearch],
    );

    return {search, input, handleChange, handleReset, sync};
}